import React from 'react';
import useAppStore from '../../store/useAppStore.js';
import StatusTable from './StatusTable.jsx';
import UnifiedChartContainer from '../Charts/UnifiedChartContainer.jsx';
import './TickerDetails.css';

export default function TickerDetails() {
  const { selectedTicker, selectedTickerData } = useAppStore();

  if (!selectedTicker) {
    return (
      <div className="ticker-details-empty">
        <p>Select a ticker to view details</p>
      </div>
    );
  }

  const ticker = selectedTickerData || {};

  return (
    <div className="ticker-details">
      <div className="ticker-header">
        <div className="ticker-title">
          <h2>{selectedTicker}</h2>
          <span className="ticker-price">
            ${ticker.price ? parseFloat(ticker.price).toFixed(2) : '—'}
          </span>
          <span className={`ticker-change ${parseFloat(ticker.change_pct || 0) >= 0 ? 'positive' : 'negative'}`}>
            {parseFloat(ticker.change_pct || 0) >= 0 ? '+' : ''}{ticker.change_pct ? parseFloat(ticker.change_pct).toFixed(2) : '0.00'}%
          </span>
        </div>

        <div className="ticker-meta">
          <div className="meta-item">
            <span className="meta-label">SMA20:</span>
            <span className="meta-value">${ticker.sma20 ? parseFloat(ticker.sma20).toFixed(2) : '—'}</span>
          </div>
          <div className="meta-item">
            <span className="meta-label">SMA200:</span>
            <span className="meta-value">${ticker.sma200 ? parseFloat(ticker.sma200).toFixed(2) : '—'}</span>
          </div>
        </div>
      </div>

      <StatusTable ticker={selectedTicker} />

      <UnifiedChartContainer ticker={selectedTicker} />
    </div>
  );
}
